import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'

const AppError1 = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_wifi_error" />
				<h3 className="intro-tit mt_20">네트워크 상태가 불안정해요.<br />연결 상태를 다시 확인해주세요.</h3>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">재시도</Button>
			</div>
		</div>
	)
}

export default AppError1